export const selectLocationHandler = (
  data,
  option,
  locations,
  isLocationSelected,
  isMachineSelected,
  selectedLocations,
) => {
  const index = locations.indexOf(option);
  const select = !isLocationSelected[index];
  const copyIsLocationSelected = [...isLocationSelected];
  copyIsLocationSelected[index] = select;

  const exitingSpecLocationsValue = Object.values(data).filter(
    (el) => el.isSpecificLocation,
  );

  const newIsSpecificLocationSelected = [];
  exitingSpecLocationsValue.forEach((specLocationTitle) => {
    const tempArr = [];

    newIsSpecificLocationSelected.push(tempArr);
    if (data[option].subLocations) {
      Object.keys(data[option].subLocations).forEach((el, index) => {
        if (el === Object.keys(specLocationTitle.subLocations)[index]) {
          tempArr.push(select);
        } else {
          tempArr.push(false);
        }
      });
    }
  });

  const machineNewArr = isMachineSelected[index]?.map((el) => {
    if (typeof el === 'boolean') {
      return select;
    } else {
      const machineArr = el?.map((machine) => select);
      return machineArr;
    }
  });
  const copyIsMachineSelected = [...isMachineSelected];
  copyIsMachineSelected[index] = machineNewArr;

  let newSelect;
  if (select) {
    newSelect = [...selectedLocations];
    if (!newSelect.some((el) => el === option)) {
      newSelect.push(option);
    }
  } else {
    newSelect = selectedLocations.filter((el) => el !== option);
  }

  return {
    locationList: copyIsLocationSelected,
    specificLocationList: newIsSpecificLocationSelected,
    machineList: copyIsMachineSelected,
    newSelectedLocations: newSelect,
    select,
  };
};
